import React from "react";
import { Link, NavLink } from "react-router-dom";
import { FiArrowRight, FiShoppingBag } from "react-icons/fi";

import {
  HABERDASHERY_SHOP_KEY,
  READY_MADE_SHOP_KEY,
  SHOP_PATHS,
  TEXTILE_SHOP_KEY,
} from "../../constants/shopMeta";

import "./BottomHeader.css";

export const SHOP_LINKS = [
  {
    label: "Haberdashery",
    shopKey: HABERDASHERY_SHOP_KEY,
    to: SHOP_PATHS[HABERDASHERY_SHOP_KEY],
  },
  {
    label: "Vintage Reproduction",
    shopKey: READY_MADE_SHOP_KEY,
    to: SHOP_PATHS[READY_MADE_SHOP_KEY],
  },
  {
    label: "Textiles",
    shopKey: TEXTILE_SHOP_KEY,
    to: SHOP_PATHS[TEXTILE_SHOP_KEY],
  },
];

export default function BottomHeader() {
  return (
    <nav className="academy-bottombar" aria-label="Shop categories">
      <div className="academy-bottombar-inner">
        <Link to="/shop" className="academy-shop-label" aria-label="Open shop">
          <FiShoppingBag aria-hidden="true" />

          <span>Shop</span>

          <FiArrowRight className="academy-shop-arrow" aria-hidden="true" />
        </Link>

        <div className="academy-shop-links">
          {SHOP_LINKS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `academy-shop-link${isActive ? " active" : ""}`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </div>
      </div>
    </nav>
  );
}
